import SavedMethods from './SavedMethods';

export default SavedMethods;
